export default [
  {
    path: '/error-404',
    name: 'error-404',
    component: () => import('@/views/error/Error404.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      action: 'read',
    },
  },
  {
    path: '/send/email/',
    name: 'auth-send-email',
    component: () => import('@/views/pages/authentication/SendConfirmationEmail.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '/email/send/',
    name: 'logged-send-email',
    component: () => import('@/views/pages/authentication/LoggedSendConfirmationEmail.vue'),
    meta: {
      resource: 'SendConfirmationEmail',
      action: 'read',
    },
  },
  {
    path: '/invoice/get/:token(.*)',
    name: 'logged-get-invoice',
    component: () => import('@/views/pages/authentication/LoggedGetInvoice.vue'),
    meta: {
      resource: 'GetInvoice',
      action: 'read',
    },
  },
  {
    path: '/get/invoice/:token(.*)',
    name: 'auth-get-invoice',
    component: () => import('@/views/pages/authentication/GetInvoice.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
      redirectIfLoggedInGetInvoice: true,
    },
  },
  {
    path: '/verify/email/:token(.*)',
    name: 'auth-verify-email',
    component: () => import('@/views/pages/authentication/VerifyEmail.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
      redirectIfLoggedInVerifyEmail: true,
      allowAuthenticated: true,
    },
  },
  {
    path: '/email/verification/:token(.*)',
    name: 'logged-verify-email',
    component: () => import('@/views/pages/authentication/LoggedVerifyEmail.vue'),
    meta: {
      resource: 'VerifyEmail',
      action: 'read',
    },
  },
  {
    path: '/login',
    name: 'auth-login',
    component: () => import('@/views/pages/authentication/Login.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '/role',
    name: 'auth-role',
    component: () => import('@/views/pages/authentication/RegisterRole.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '/register',
    name: 'auth-register',
    component: () => import('@/views/pages/authentication/Register.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '/forgot-password',
    name: 'auth-forgot-password',
    component: () => import('@/views/pages/authentication/ForgotPassword.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '/reset-password/:token(.*)',
    name: 'auth-reset-password',
    component: () => import('@/views/pages/authentication/ResetPassword.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '/pages/miscellaneous/coming-soon',
    name: 'misc-coming-soon',
    component: () => import('@/views/pages/miscellaneous/ComingSoon.vue'),
    meta: {
      layout: 'full',
    },
  },
  {
    path: '/not-authorized',
    name: 'misc-not-authorized',
    component: () => import('@/views/pages/miscellaneous/NotAuthorized.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      action: 'read',
    },
  },
  {
    path: '/pages/miscellaneous/under-maintenance',
    name: 'misc-under-maintenance',
    component: () => import('@/views/pages/miscellaneous/UnderMaintenance.vue'),
    meta: {
      layout: 'full',
    },
  },
  {
    path: '/payerror',
    name: 'payment-error',
    component: () => import('@/views/pages/miscellaneous/PaymentError.vue'),
    meta: {
      redirectIfLoggedIn: true,
      resource: 'Auth',
      action: 'read',
      layout: 'full',
    },
  },
  {
    path: '/pages/miscellaneous/error',
    name: 'misc-error',
    component: () => import('@/views/pages/miscellaneous/Error.vue'),
    meta: {
      layout: 'full',
    },
  },
  {
    path: '/pages/account-setting',
    name: 'pages-account-setting',
    component: () => import('@/views/pages/account-setting/AccountSetting.vue'),
    meta: {
      resource: 'AccountSettings',
      action: 'read',
      pageTitle: 'Account Settings',
      breadcrumb: [
        {
          text: 'Pages',
        },
        {
          text: 'Account Settings',
          active: true,
        },
      ],
    },
  },
  {
    path: '/pages/profile',
    name: 'pages-profile',
    redirect: { name: 'pages-account-setting' },
    meta: {
      resource: 'AccountSettings',
      action: 'read',
      pageTitle: 'Profile',
      navActiveLink: 'pages-account-setting',
      breadcrumb: [
        {
          text: 'Pages',
        },
        {
          text: 'Profile',
          active: true,
        },
      ],
    },
  },
]
